(function () {
	'use strict';
	$(document).ready(function () {

		// SOCIAL SHARING
		const $share = $('#share');
		$share.css('opacity', 1);
		$share.jsSocials({
			showLabel: false,
			showCount: false,
			shareIn: "popup",
			text: document.title,
			url: window.location.href,
			shares: [
				{
					share: "facebook",
					logo: fhGetConfig('template_uri') + '/dist/images/facebook.svg',
					inlineSvg: true,
				},
				{
					share: "twitter",
					logo: fhGetConfig('template_uri') + '/dist/images/twitter.svg',
					inlineSvg: true,
					via: "pgnig",
				},
				{
					share: "linkedin",
					logo: fhGetConfig('template_uri') + '/dist/images/linkedin.svg',
					inlineSvg: true,
				}
			]
		});

		// handle tables in accordions
		$('.subpage .accordion .collapse').on('shown.bs.collapse', function () {
			updateTableSize();
			$(window).resize();
		});

		// accordion scroll animation
		$('.subpage .accordion.scroll-animation .collapse').on('shown.bs.collapse', function () {
			const positionTop = $(this).parent().offset().top; // - $('header').height();
			$('html, body').animate({
				scrollTop: positionTop
			}, 500);
		});

		// responsive-image module zoomable feature
		document.querySelectorAll('.module.responsive-image .image-container.zoomable .desktop-image').forEach((containerElement) => {
			const popupContainer = document.createElement('div');
			popupContainer.classList.add('popup-image-container');
			const clonedImg = containerElement.parentElement.querySelector('.popup-image img').cloneNode(true);
			clonedImg.classList.add('popup-image');
			popupContainer.appendChild(clonedImg);

			const removePopupContainer = () => {
				$(popupContainer).fadeOut(() => {
					popupContainer.remove();
				});
			};
			popupContainer.addEventListener('click', removePopupContainer);

			const mediaQuery = window.matchMedia('(min-width: 768px)');
			mediaQuery.addEventListener('change', () => {
				if (!mediaQuery.matches) {
					removePopupContainer();
				}
			})
			containerElement.querySelector('img').addEventListener('click', () => {
				if (mediaQuery.matches) {
					document.body.appendChild(popupContainer);
					$(popupContainer).fadeIn();
				}
			})
		});

		//Tooltipster

		// default tooltips
		$('.default-tooltipster').tooltipster({
			maxWidth: 290,
			contentAsHTML: true,
			interactive: true,
			functionPosition: function (instance, helper, position) {
				position.coord.left = helper.geo.origin.offset.left - 20;
				return position;
			},
		});

		//slider-with-tiles
		$('.subpage .swiper.swiper-with-tiles').each(function () {
			const $this = $(this);
			new Swiper($this[0], {
				slidesPerView: 1,
				spaceBetween: 15,
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				navigation: {
					lockClass: 'navigation-lock',
					prevEl: $this.parent().find('.navigation-button-prev')[0],
					nextEl: $this.parent().find('.navigation-button-next')[0],
				},
				breakpoints: {
					1200: {
						slidesPerView: 4
					},
					991: {
						slidesPerView: 3
					},
					768: {
						slidesPerView: 2
					}
				}
			})
		});
	});
}(jQuery));
